/* eslint-disable no-extra-boolean-cast */
/* eslint-disable new-cap */
import { HTTP_STATUS_OK } from '../../../smartpak/httpstatus';
import spAddToCart from '../../../vendor/googletagmanager/spevents/spaddtocart';

const SUPPLY = 2;

function convertProductClassToItemId(id) {
    var NUM_TO_ADD_TO_ID = 10000;
    return id + NUM_TO_ADD_TO_ID;
}

function formatItem(item) {
    return {
        productId: item.ProductId,
        quantity: item.Quantity,
        itemPrice: item.DiscountedPrice,
        itemId: convertProductClassToItemId(item.ProductClassId),
        cartItemId: item.ItemId,
        productClassId: item.ProductClassId,
        name: item.ProductClassName,
        cost: !!item.Cost ? item.Cost : item.ConditionalItemFullCharge
    };
}

var events = {
    _triggerEvent: function (data) {
        if (window.dataLayer && window.dataLayer.push) {
            window.dataLayer.push(data);
        }
    },
    _getCartData: function () {
        return fetch('/api/shoppingcart/GetCartItems')
            .then(response => response.json())
            .then(response => {
                if (response.Status !== HTTP_STATUS_OK) {
                    return [];
                }

                return (response.Content.CartItems || []).reduce(function (items, item) {
                    if (item.ProductType === SUPPLY) {
                        items.push(formatItem(item));
                    } else {
                        item.SupplementViewModels.forEach(supplement => items.push(formatItem(supplement)));
                    }

                    return items
                        .sort((a, b) => a.cartItemId < b.cartItemId ? -1 : 1)
                        .map(function (item) {
                            delete item.cartItemId;
                            return item;
                        });
                }, []);
            });
    },
    _formatForDYEvent: function (data) {
        return {
            value: data.price,
            currency: 'USD',
            productId: data.sku + '',
            quantity: data.quantity,
            cart: data.cart.map(item => {
                return {
                    ...item,
                    productId: item.productId.toString()
                };
            })
        };
    },
    _dynamicYieldAddToCart: function (data) {
        if (window.DY && window.DY.API) {
            window.DY.API('event', {
                name: 'Add to Cart',
                properties: {
                    dyType: 'add-to-cart-v1',
                    ...this._formatForDYEvent(data)
                }
            });
        }
    },
    _dynamicYieldRemoveFromCart: function (data) {
        if (window.DY && window.DY.API) {
            window.DY.API('event', {
                name: 'Remove from Cart',
                properties: {
                    dyType: 'remove-from-cart-v1',
                    ...this._formatForDYEvent(data)
                }
            });
        }
    },
    _getDataForEvents() {
        return new Promise(resolve => {
            this._getCartData().then(cartItems => {
                resolve(cartItems);
            });
        });
    },
    _spAddToCart: function ({ isAutoShip, brand, childReportingCategory, itemNumber, name, parentReportingCategory, isPrivateLabel, isSmartPak, id, price, quantity }) {
        spAddToCart({
            childReportingCategory,
            parentReportingCategory,
            brand,
            name,
            isPrivateLabel,
            isAutoShip,
            isSmartPak,
            itemNumber: itemNumber.toString(),
            id: id.toString(),
            quantity: quantity.toString(),
            price: price.toString()
        });
    },
    addCartItem: function ({ isAutoShip, brand, itemNumber, productClassId, name, childReportingCategory, parentReportingCategory, isPrivateLabel, isSmartPak, id, price, quantity }) {
        return this._getDataForEvents().then(cart => {
            this._spAddToCart({
                isAutoShip,
                brand,
                childReportingCategory,
                itemNumber,
                productClassId,
                name,
                parentReportingCategory,
                isPrivateLabel,
                isSmartPak,
                id,
                price,
                quantity
            });

            this._dynamicYieldAddToCart({
                sku: id,
                price,
                quantity,
                cart
            });
        });
    },
    removeCartItem: function ({ sku, price, quantity, id }) {
        return this._getDataForEvents().then(cart => {
            const data = {
                sku,
                price,
                quantity,
                itemId: convertProductClassToItemId(id),
                productClassId: id,
                cart
            };

            this._triggerEvent({
                event: 'removeFromCart',
                ...data
            });

            this._dynamicYieldRemoveFromCart(data);
        });
    }
};

export default events;
